query personOverlayAttributeKeys {
  personOverlayAttributeKeys {
    key
    label
    kind
    powerOrAdminOnly
  }
}
